(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-specifications"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('component-specifications')) {
    class ComponentSpecifications extends HTMLElement {
      connectedCallback() {
        this.desktopLayout = this.dataset.desktopLayout || this.dataset.layout || 'tabs';
        this.mobileLayout = this.dataset.mobileLayout || 'accordion';
        this.mobileMedia = window.matchMedia('(max-width: 699px)');
        this.layout = this.resolveLayout();
        this.dataset.layout = this.layout;
        this.components = [...this.querySelectorAll(':scope [data-specification-component]')];
        this.navigation = this.querySelector('[data-component-navigation]');
        this.tabList = this.querySelector('[data-component-tabs]');
        this.previousButton = this.querySelector('[data-component-nav-previous]');
        this.nextButton = this.querySelector('[data-component-nav-next]');
        this.abortController = new AbortController();
        this.activeIndex = 0;
        this.rowLimit = Math.max(0, Number(this.dataset.rowLimit) || 0);
        this.rowToggles = new Map();
        const signal = this.abortController.signal;

        this.classList.toggle('is-empty', this.components.length === 0);
        this.buildTabs();
        this.setupRowLimits();

        this.components.forEach((component, index) => {
          component.querySelector('[data-component-trigger]')?.addEventListener('click', () => {
            if (this.layout === 'accordion') {
              this.toggleAccordion(index);
            }
          }, { signal });
        });

        this.previousButton?.addEventListener('click', () => this.scrollTabs(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scrollTabs(1), { signal });
        this.tabList?.addEventListener('scroll', () => this.updateNavigation(), { signal, passive: true });
        window.addEventListener('resize', () => this.updateNavigation(), { signal, passive: true });
        this.mobileMedia.addEventListener('change', () => this.updateResponsiveLayout(), { signal });
        this.addEventListener('shopify:block:select', (event) => this.selectEditorBlock(event), { signal });

        this.setActive(0, { focus: false, scroll: false });
        requestAnimationFrame(() => this.updateNavigation());
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      resolveLayout() {
        return this.mobileMedia.matches ? this.mobileLayout : this.desktopLayout;
      }

      updateResponsiveLayout() {
        const nextLayout = this.resolveLayout();
        if (nextLayout === this.layout) {
          return;
        }

        this.layout = nextLayout;
        this.dataset.layout = nextLayout;
        this.buildTabs();
        this.setActive(this.activeIndex >= 0 ? this.activeIndex : 0, { focus: false, scroll: false });
        requestAnimationFrame(() => this.updateNavigation());
      }

      buildTabs() {
        if (!this.tabList || !this.navigation || this.layout !== 'tabs' || this.components.length === 0) {
          this.tabButtons = [];
          this.tabList?.replaceChildren();
          if (this.navigation) {
            this.navigation.hidden = true;
          }
          return;
        }

        this.tabList.replaceChildren();
        this.tabButtons = this.components.map((component, index) => {
          const button = document.createElement('button');
          const title = component.dataset.componentTitle || `Component ${index + 1}`;
          const badge = component.dataset.componentBadge;
          button.type = 'button';
          button.className = 'component-specifications__tab';
          button.id = `${component.id}-tab`;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', component.querySelector('[data-component-panel]')?.id || '');
          button.innerHTML = `<span></span>${badge ? '<span class="component-specifications__tab-badge"></span>' : ''}`;
          button.firstElementChild.textContent = title;
          if (badge) {
            button.lastElementChild.textContent = badge;
          }
          button.addEventListener('click', () => this.setActive(index, { focus: true, scroll: true }), {
            signal: this.abortController.signal
          });
          button.addEventListener('keydown', (event) => this.handleTabKeydown(event, index), {
            signal: this.abortController.signal
          });
          this.tabList.appendChild(button);
          return button;
        });

        this.navigation.hidden = false;
      }

      setupRowLimits() {
        if (this.rowLimit <= 0) {
          return;
        }

        this.components.forEach((component) => {
          const list = component.querySelector('.component-specification__list');
          const items = list ? [...list.children] : [];
          const rows = items.filter((item) => item.matches('[data-specification-row]'));
          if (!list || rows.length <= this.rowLimit) {
            return;
          }

          const button = document.createElement('button');
          const label = document.createElement('span');
          button.type = 'button';
          button.className = 'component-specification__row-toggle';
          button.setAttribute('aria-controls', list.id);
          button.setAttribute('aria-expanded', 'false');
          button.append(label, this.createToggleIcon());
          button.addEventListener('click', () => {
            const state = this.rowToggles.get(component);
            this.setRowsExpanded(component, !state?.expanded);
          }, { signal: this.abortController.signal });
          list.insertAdjacentElement('afterend', button);

          this.rowToggles.set(component, { button, label, items, expanded: false });
          this.setRowsExpanded(component, false);
        });
      }

      createToggleIcon() {
        const wrapper = document.createElement('span');
        wrapper.innerHTML = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m3.5 6 4.5 4 4.5-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        return wrapper.firstElementChild;
      }

      setRowsExpanded(component, expanded) {
        const state = this.rowToggles.get(component);
        if (!state) {
          return;
        }

        let visibleRows = 0;
        let limitReached = false;
        state.items.forEach((item) => {
          let shouldHide = limitReached;
          if (item.matches('[data-specification-row]')) {
            visibleRows += 1;
            shouldHide = visibleRows > this.rowLimit;
            if (visibleRows >= this.rowLimit) {
              limitReached = true;
            }
          }
          item.hidden = !expanded && shouldHide;
        });

        state.expanded = expanded;
        state.button.setAttribute('aria-expanded', String(expanded));
        state.label.textContent = expanded
          ? (this.dataset.showLessLabel || 'Show less')
          : (this.dataset.showMoreLabel || 'Show more');
      }

      setActive(index, { focus = false, scroll = false } = {}) {
        if (this.components.length === 0) {
          return;
        }

        this.activeIndex = Math.max(0, Math.min(index, this.components.length - 1));

        this.components.forEach((component, componentIndex) => {
          const isActive = componentIndex === this.activeIndex;
          const trigger = component.querySelector('[data-component-trigger]');
          const panel = component.querySelector('[data-component-panel]');
          component.classList.toggle('is-active', this.layout === 'stack' || isActive);
          component.hidden = this.layout === 'tabs' && !isActive;
          trigger?.setAttribute('aria-expanded', String(this.layout === 'stack' || isActive));
          panel?.setAttribute('aria-hidden', String(this.layout !== 'stack' && !isActive));

          if (this.layout === 'tabs' && panel && this.tabButtons?.[componentIndex]) {
            panel.setAttribute('aria-labelledby', this.tabButtons[componentIndex].id);
          } else if (panel && trigger) {
            panel.setAttribute('aria-labelledby', trigger.id);
          }
        });

        this.tabButtons?.forEach((button, buttonIndex) => {
          const isActive = buttonIndex === this.activeIndex;
          button.setAttribute('aria-selected', String(isActive));
          button.tabIndex = isActive ? 0 : -1;
        });

        const activeButton = this.tabButtons?.[this.activeIndex];
        if (focus) {
          activeButton?.focus({ preventScroll: true });
        }
        if (scroll) {
          activeButton?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        this.updateNavigation();
      }

      toggleAccordion(index) {
        const component = this.components[index];
        if (!component) {
          return;
        }

        if (component.classList.contains('is-active')) {
          component.classList.remove('is-active');
          component.querySelector('[data-component-trigger]')?.setAttribute('aria-expanded', 'false');
          component.querySelector('[data-component-panel]')?.setAttribute('aria-hidden', 'true');
          this.activeIndex = -1;
        } else {
          this.setActive(index, { focus: false, scroll: false });
        }
      }

      handleTabKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          return;
        }

        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + this.components.length) % this.components.length;
        } else if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % this.components.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.components.length - 1;
        }
        this.setActive(nextIndex, { focus: true, scroll: true });
      }

      scrollTabs(direction) {
        this.tabList?.scrollBy({
          left: direction * Math.max(240, this.tabList.clientWidth * .7),
          behavior: 'smooth'
        });
      }

      updateNavigation() {
        if (!this.tabList || this.layout !== 'tabs') {
          return;
        }

        const hasOverflow = this.tabList.scrollWidth > this.tabList.clientWidth + 2;
        if (this.previousButton) {
          this.previousButton.hidden = !hasOverflow;
          this.previousButton.disabled = this.tabList.scrollLeft <= 2;
        }
        if (this.nextButton) {
          this.nextButton.hidden = !hasOverflow;
          this.nextButton.disabled = this.tabList.scrollLeft + this.tabList.clientWidth >= this.tabList.scrollWidth - 2;
        }
      }

      selectEditorBlock(event) {
        const component = event.target.closest('[data-specification-component]');
        const index = this.components.indexOf(component);
        if (index >= 0 && this.layout !== 'stack') {
          this.setActive(index, { focus: false, scroll: true });
        }
        if (component && event.target.closest('[data-specification-row], [data-specification-heading], [data-specification-note]')) {
          this.setRowsExpanded(component, true);
        }
      }
    }

    customElements.define('component-specifications', ComponentSpecifications);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-info-blocks')) {
    class ProductInfoBlocks extends HTMLElement {
      connectedCallback() {
        this.wrapAppBlocks();
        this.groupItems(
          (item) => item.dataset.blockType === 'offer',
          'product-info__offer-list',
          'product-info__offer-list'
        );
        this.groupItems(
          (item) =>
            ['collapsible-text', 'description', 'disclosures'].includes(item.dataset.blockType) &&
            item.querySelector('.accordion'),
          'accordion-group',
          'accordion-group'
        );
      }

      wrapAppBlocks() {
        Array.from(this.children).forEach((child) => {
          if (child.matches('.product-info__block-item, .product-info__block-group')) {
            return;
          }

          const wrapper = document.createElement('div');
          wrapper.className = 'product-info__block-item';
          wrapper.dataset.blockType = 'app';
          child.before(wrapper);
          wrapper.append(child);
        });
      }

      groupItems(predicate, className, groupName) {
        let group = [];

        const flush = () => {
          if (group.length > 1) {
            const wrapper = document.createElement('div');
            wrapper.className = `product-info__block-group ${className}`;
            wrapper.dataset.groupType = groupName;
            group[0].before(wrapper);
            group.forEach((item) => wrapper.append(item));
          }

          group = [];
        };

        Array.from(this.children).forEach((item) => {
          if (item.matches('.product-info__block-item') && predicate(item)) {
            group.push(item);
          } else {
            flush();
          }
        });

        flush();
      }
    }

    customElements.define('product-info-blocks', ProductInfoBlocks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-content-list-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('media-content-list-slider')) {
    class MediaContentListSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-media-list-track]');
        this.viewport = this.querySelector('.media-content-list__viewport');
        this.originalCards = [...this.track.querySelectorAll(':scope > [data-media-content-card]')];
        this.previousButton = this.querySelector('[data-media-list-previous]');
        this.nextButton = this.querySelector('[data-media-list-next]');
        this.currentOutput = this.querySelector('[data-media-list-current]');
        this.progressFill = this.querySelector('[data-media-list-progress-fill]');
        this.dots = [...this.querySelectorAll('[data-media-list-dot]')];
        this.dialog = this.querySelector('[data-media-list-dialog]');
        this.player = this.querySelector('[data-media-list-player]');
        this.closeButton = this.querySelector('[data-media-list-close]');
        this.detailDialog = this.querySelector('[data-media-list-detail-dialog]');
        this.detailHost = this.querySelector('[data-media-list-detail-host]');
        this.detailCloseButton = this.querySelector('[data-media-list-detail-close]');
        this.abortController = new AbortController();
        this.autoplayTimer = null;
        this.normalizeTimer = null;
        this.previewCard = null;
        this.isHovered = false;
        this.focusIsWithin = false;
        this.pointerInitiatedFocus = false;
        this.autoplayFocusOverride = false;
        this.activeIndex = 0;
        this.lastVideoTrigger = null;
        this.lastDetailTrigger = null;
        this.loopEnabled = this.dataset.loop === 'true' && this.originalCards.length > 1;
        const signal = this.abortController.signal;

        this.classList.toggle('is-empty', this.originalCards.length === 0);
        this.classList.toggle('is-single', this.originalCards.length <= 1);

        if (this.loopEnabled) {
          this.setupInfiniteLoop();
        }

        this.allCards = [...this.track.querySelectorAll(':scope > [data-media-content-card]')];

        this.previousButton?.addEventListener('click', () => this.scrollByCard(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scrollByCard(1), { signal });
        this.track?.addEventListener('scroll', () => this.handleTrackScroll(), { signal, passive: true });
        this.track?.addEventListener('pointerdown', () => this.stopAutoplay(), { signal, passive: true });
        this.track?.addEventListener('pointerup', () => this.scheduleNormalization(), { signal, passive: true });
        this.track?.addEventListener('pointercancel', () => this.scheduleNormalization(), { signal, passive: true });
        this.addEventListener('mouseenter', () => {
          this.isHovered = true;
          this.stopAutoplay();
        }, { signal });
        this.addEventListener('mouseleave', () => {
          this.isHovered = false;
          this.startAutoplay();
        }, { signal });
        this.addEventListener('pointerdown', () => {
          this.autoplayFocusOverride = false;
          this.pointerInitiatedFocus = true;
        }, { signal, capture: true, passive: true });
        this.addEventListener('keydown', () => {
          this.autoplayFocusOverride = false;
          this.pointerInitiatedFocus = false;
          this.focusIsWithin = true;
          this.stopAutoplay();
        }, { signal, capture: true });
        this.addEventListener('focusin', () => {
          if (this.pointerInitiatedFocus || this.autoplayFocusOverride) {
            this.focusIsWithin = false;
            return;
          }
          this.focusIsWithin = true;
          this.stopAutoplay();
        }, { signal });
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) {
              this.focusIsWithin = false;
              this.startAutoplay();
            }
          });
        }, { signal });
        this.addEventListener('click', (event) => {
          const videoTrigger = event.target.closest('[data-media-list-play]');
          if (videoTrigger && this.contains(videoTrigger)) {
            this.openVideo(videoTrigger);
            return;
          }

          const detailTrigger = event.target.closest('[data-media-list-details]');
          if (detailTrigger && this.contains(detailTrigger)) {
            this.openDetails(detailTrigger.closest('[data-media-content-card]'), detailTrigger);
            return;
          }

          const card = event.target.closest('[data-media-content-card]');
          const interactiveTarget = event.target.closest('a, button, input, select, textarea, summary');
          if (card?.classList.contains('has-overflowing-description') && this.contains(card) && !interactiveTarget) {
            this.openDetails(card, card.querySelector('[data-media-list-details]'));
          }
        }, { signal });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goToCard(Number(dot.dataset.index)), { signal });
        });
        this.closeButton?.addEventListener('click', () => this.dialog?.close(), { signal });
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            this.dialog.close();
          }
        }, { signal });
        this.dialog?.addEventListener('close', () => this.closeVideo(), { signal });
        this.detailCloseButton?.addEventListener('click', () => this.detailDialog?.close(), { signal });
        this.detailDialog?.addEventListener('click', (event) => {
          if (event.target === this.detailDialog) {
            this.detailDialog.close();
          }
        }, { signal });
        this.detailDialog?.addEventListener('close', () => this.closeDetails(), { signal });
        window.addEventListener('resize', () => this.handleResize(), { signal, passive: true });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopAutoplay();
            this.stopActivePreview();
          } else {
            this.updateActiveCard();
            this.startAutoplay();
          }
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => this.selectEditorBlock(event), { signal });

        document.fonts?.ready.then(() => {
          if (this.isConnected) {
            this.updateDetailAvailability();
          }
        });

        requestAnimationFrame(() => {
          this.measureRightBleed();
          this.measureLoop();
          if (this.loopEnabled) {
            this.jumpTo(this.loopStart);
          }
          this.updateDetailAvailability();
          this.updateProgress();
          this.updateControls();
          this.startAutoplay();
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.stopAutoplay();
        this.stopActivePreview();
        window.clearTimeout(this.normalizeTimer);
        this.player?.replaceChildren();
        this.detailHost?.replaceChildren();
      }

      setupInfiniteLoop() {
        const before = this.originalCards.map((card) => this.createLoopClone(card));
        const after = this.originalCards.map((card) => this.createLoopClone(card));
        this.track.prepend(...before);
        this.track.append(...after);
      }

      createLoopClone(card) {
        const clone = card.cloneNode(true);
        clone.dataset.carouselClone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => element.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', '-1'));
        return clone;
      }

      measureLoop() {
        const card = this.originalCards[0];
        if (!card || !this.track) {
          this.cardStep = 0;
          this.cycleWidth = 0;
          this.loopStart = 0;
          return;
        }

        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        this.cardStep = card.offsetWidth + gap;
        this.cycleWidth = this.originalCards.length * this.cardStep;
        this.loopStart = this.loopEnabled ? this.cycleWidth : 0;

      }

      measureRightBleed() {
        if (!this.viewport) {
          return;
        }

        this.viewport.style.width = '';
        this.viewport.style.removeProperty('--media-list-card-width');

        const isMobile = window.matchMedia('(max-width: 699px)').matches;
        if (!isMobile) {
          const baseCard = this.originalCards[0];
          const baseCardWidth = baseCard?.getBoundingClientRect().width || 0;
          if (baseCardWidth > 0) {
            this.viewport.style.setProperty('--media-list-card-width', `${baseCardWidth}px`);
          }
        }

        const bounds = this.viewport.getBoundingClientRect();
        const documentWidth = document.documentElement.clientWidth;
        const isRtl = window.getComputedStyle(this).direction === 'rtl';
        const inlineStart = isRtl ? documentWidth - bounds.right : bounds.left;
        this.viewport.style.width = `${Math.max(0, documentWidth - inlineStart)}px`;
      }

      scrollByCard(direction) {
        if (!this.track || !this.cardStep || this.originalCards.length <= 1) {
          return;
        }

        this.stopAutoplay();
        this.normalizeLoop();
        this.track.scrollBy({ left: direction * this.cardStep, behavior: 'smooth' });
      }

      goToCard(index) {
        if (!this.track || !this.cardStep || !Number.isFinite(index)) {
          return;
        }

        this.stopAutoplay();
        const safeIndex = Math.max(0, Math.min(index, this.originalCards.length - 1));
        this.track.scrollTo({
          left: this.loopStart + safeIndex * this.cardStep,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      updateDetailAvailability() {
        this.allCards?.forEach((card) => {
          const description = card.querySelector('.media-content-card__description');
          const detailButton = card.querySelector('[data-media-list-details]');
          const isOverflowing = Boolean(
            description
            && detailButton
            && description.scrollHeight > description.clientHeight + 1
          );

          card.classList.toggle('has-overflowing-description', isOverflowing);
          if (detailButton) {
            detailButton.hidden = !isOverflowing;
          }
        });
      }

      scheduleNormalization() {
        window.clearTimeout(this.normalizeTimer);
        this.normalizeTimer = window.setTimeout(() => {
          this.normalizeLoop();
          this.updateProgress();
          this.updateControls();
          this.startAutoplay();
        }, 140);
      }

      handleTrackScroll() {
        this.stopActivePreview();
        this.scheduleNormalization();
      }

      normalizeLoop() {
        if (!this.loopEnabled || !this.cycleWidth || !this.cardStep || !this.track) {
          return;
        }

        const lowerBoundary = this.loopStart - this.cardStep / 2;
        const upperBoundary = this.loopStart + this.cycleWidth - this.cardStep / 2;
        if (this.track.scrollLeft < lowerBoundary) {
          this.jumpTo(this.track.scrollLeft + this.cycleWidth);
        } else if (this.track.scrollLeft >= upperBoundary) {
          this.jumpTo(this.track.scrollLeft - this.cycleWidth);
        }
      }

      jumpTo(left) {
        if (!this.track || !Number.isFinite(left)) {
          return;
        }

        const previousBehavior = this.track.style.scrollBehavior;
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = left;
        requestAnimationFrame(() => {
          this.track.style.scrollBehavior = previousBehavior;
        });
      }

      getLogicalIndex() {
        if (!this.cardStep || this.originalCards.length === 0) {
          return 0;
        }

        const rawIndex = Math.round((this.track.scrollLeft - this.loopStart) / this.cardStep);
        if (!this.loopEnabled) {
          return Math.max(0, Math.min(rawIndex, this.originalCards.length - 1));
        }
        return ((rawIndex % this.originalCards.length) + this.originalCards.length) % this.originalCards.length;
      }

      updateProgress() {
        this.activeIndex = this.getLogicalIndex();
        const current = this.activeIndex + 1;
        if (this.currentOutput) {
          this.currentOutput.textContent = String(current).padStart(2, '0');
        }
        if (this.progressFill) {
          this.progressFill.style.width = `${(current / Math.max(1, this.originalCards.length)) * 100}%`;
        }
        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === this.activeIndex));
        });
        this.updateActiveCard();
      }

      getActivePhysicalCard() {
        if (!this.track) {
          return null;
        }

        const cards = [...this.track.querySelectorAll(':scope > [data-media-content-card]')];
        const trackLeft = this.track.getBoundingClientRect().left;
        let activeCard = null;
        let closestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeCard = card;
          }
        });

        return activeCard;
      }

      updateActiveCard() {
        const activeCard = this.getActivePhysicalCard();
        this.classList.toggle('has-active-card', Boolean(activeCard));
        this.track?.querySelectorAll(':scope > [data-media-content-card]').forEach((card) => {
          const isActive = card === activeCard;
          card.classList.toggle('is-active', isActive);
          if (isActive) {
            card.setAttribute('aria-current', 'true');
          } else {
            card.removeAttribute('aria-current');
          }
        });

        this.startActivePreview(activeCard);
      }

      startActivePreview(card) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const trigger = card?.querySelector('[data-media-list-play]');
        const container = card?.querySelector('[data-media-list-inline-player]');
        if (
          !trigger
          || !container
          || reducedMotion
          || document.hidden
          || this.dialog?.open
          || this.detailDialog?.open
        ) {
          this.stopActivePreview();
          return;
        }

        if (this.previewCard === card && !container.hidden) {
          return;
        }

        this.stopActivePreview();
        const provider = trigger.dataset.videoProvider;
        const videoId = trigger.dataset.videoId;

        if (provider === 'shopify') {
          const template = card.querySelector('[data-media-list-video-template]');
          if (!template) {
            return;
          }

          container.appendChild(template.content.cloneNode(true));
          const video = container.querySelector('video');
          if (!video) {
            container.replaceChildren();
            return;
          }
          video.muted = true;
          video.defaultMuted = true;
          video.controls = false;
          video.loop = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.play().catch(() => {});
        } else if (videoId) {
          const iframe = document.createElement('iframe');
          const encodedId = encodeURIComponent(videoId);
          iframe.src = provider === 'vimeo'
            ? `https://player.vimeo.com/video/${encodedId}?autoplay=1&muted=1&loop=1&background=1`
            : `https://www.youtube-nocookie.com/embed/${encodedId}?autoplay=1&mute=1&controls=0&playsinline=1&rel=0&loop=1&playlist=${encodedId}`;
          iframe.title = trigger.getAttribute('aria-label') || 'Video preview';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.tabIndex = -1;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          container.appendChild(iframe);
        } else {
          return;
        }

        this.previewCard = card;
        container.hidden = false;
        container.setAttribute('aria-hidden', 'false');
      }

      stopActivePreview() {
        if (!this.previewCard) {
          return;
        }

        const container = this.previewCard.querySelector('[data-media-list-inline-player]');
        container?.querySelector('video')?.pause();
        container?.replaceChildren();
        if (container) {
          container.hidden = true;
          container.setAttribute('aria-hidden', 'true');
        }
        this.previewCard = null;
      }

      updateControls() {
        const disabled = this.originalCards.length <= 1;
        if (this.previousButton) {
          this.previousButton.disabled = disabled || (!this.loopEnabled && this.activeIndex === 0);
        }
        if (this.nextButton) {
          this.nextButton.disabled = disabled || (!this.loopEnabled && this.activeIndex === this.originalCards.length - 1);
        }
      }

      handleResize() {
        const logicalIndex = this.getLogicalIndex();
        this.measureRightBleed();
        this.measureLoop();
        this.jumpTo(this.loopStart + logicalIndex * this.cardStep);
        this.updateDetailAvailability();
        this.updateProgress();
        this.updateControls();
        this.startAutoplay();
      }

      startAutoplay() {
        this.stopAutoplay();
        const enabled = this.dataset.autoplay === 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (
          !enabled
          || reducedMotion
          || document.hidden
          || this.isHovered
          || (this.focusIsWithin && !this.autoplayFocusOverride)
          || this.dialog?.open
          || this.detailDialog?.open
          || this.originalCards.length <= 1
          || (!this.loopEnabled && this.activeIndex === this.originalCards.length - 1)
        ) {
          return;
        }

        const interval = Math.max(3000, Number(this.dataset.autoplayInterval) || 6000);
        this.autoplayTimer = window.setTimeout(() => this.scrollByCard(1), interval);
        this.classList.add('is-autoplay-running');
      }

      stopAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
        this.classList.remove('is-autoplay-running');
      }

      openVideo(trigger) {
        if (!this.dialog || !this.player) {
          return;
        }

        const provider = trigger.dataset.videoProvider;
        const videoId = trigger.dataset.videoId;
        const card = trigger.closest('[data-media-content-card]');
        this.lastVideoTrigger = trigger;
        this.stopAutoplay();
        this.stopActivePreview();

        if (provider === 'shopify') {
          const template = card?.querySelector('[data-media-list-video-template]');
          if (!template) {
            return;
          }
          this.player.appendChild(template.content.cloneNode(true));
        } else if (videoId) {
          const iframe = document.createElement('iframe');
          const encodedId = encodeURIComponent(videoId);
          iframe.src = provider === 'vimeo'
            ? `https://player.vimeo.com/video/${encodedId}?autoplay=1`
            : `https://www.youtube-nocookie.com/embed/${encodedId}?autoplay=1&playsinline=1&rel=0`;
          iframe.title = trigger.getAttribute('aria-label') || 'Video';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          this.player.replaceChildren(iframe);
        } else {
          return;
        }

        this.dialog.showModal();
        this.player.querySelector('video')?.play().catch(() => {});
      }

      closeVideo() {
        this.player?.replaceChildren();
        this.autoplayFocusOverride = true;
        this.focusIsWithin = false;
        this.lastVideoTrigger?.focus({ preventScroll: true });
        this.lastVideoTrigger = null;
        requestAnimationFrame(() => {
          this.updateActiveCard();
          this.startAutoplay();
        });
      }

      openDetails(card, trigger) {
        if (!card || !this.detailDialog || !this.detailHost) {
          return;
        }

        const template = card.querySelector('[data-media-list-detail-template]');
        if (!template) {
          return;
        }

        this.stopAutoplay();
        this.stopActivePreview();
        this.lastDetailTrigger = trigger || null;
        this.detailHost.replaceChildren(template.content.cloneNode(true));
        this.detailDialog.classList.toggle(
          'has-media',
          Boolean(this.detailHost.querySelector('.media-content-list__detail-media'))
        );
        this.detailDialog.showModal();
      }

      closeDetails() {
        this.detailHost?.replaceChildren();
        this.detailDialog?.classList.remove('has-media');
        this.autoplayFocusOverride = true;
        this.focusIsWithin = false;
        this.lastDetailTrigger?.focus({ preventScroll: true });
        this.lastDetailTrigger = null;
        requestAnimationFrame(() => {
          this.updateActiveCard();
          this.startAutoplay();
        });
      }

      selectEditorBlock(event) {
        const card = event.target.closest('[data-media-content-card]');
        if (!card || card.hasAttribute('data-carousel-clone')) {
          return;
        }
        const index = this.originalCards.indexOf(card);
        if (index >= 0) {
          this.goToCard(index);
        }
      }
    }

    customElements.define('media-content-list-slider', MediaContentListSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-follow-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('social-follow-gallery')) {
    class SocialFollowGallery extends HTMLElement {
      connectedCallback() {
        this.layout = this.dataset.layout;
        this.track = this.querySelector('[data-social-follow-track]');
        this.cards = [...this.querySelectorAll('[data-social-follow-card]')];
        this.previousButton = this.querySelector('[data-social-follow-previous]');
        this.nextButton = this.querySelector('[data-social-follow-next]');
        this.abortController = new AbortController();
        this.autoplayTimer = null;
        this.scrollTimer = null;
        this.paused = false;
        this.hasOverflow = false;
        this.isRtl = false;
        const signal = this.abortController.signal;

        if (this.layout !== 'carousel' || !this.track || this.cards.length === 0) {
          this.classList.add('is-static');
          return;
        }

        this.previousButton?.addEventListener('click', () => this.move(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.handleScroll(), { signal, passive: true });
        this.track.addEventListener('pointerdown', () => this.pause(), { signal, passive: true });
        this.track.addEventListener('pointerup', () => this.resume(), { signal, passive: true });
        this.track.addEventListener('pointercancel', () => this.resume(), { signal, passive: true });
        this.addEventListener('mouseenter', () => this.pause(), { signal });
        this.addEventListener('mouseleave', () => this.resume(), { signal });
        this.addEventListener('focusin', () => this.pause(), { signal });
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) {
              this.resume();
            }
          });
        }, { signal });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        }, { signal });

        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);

        requestAnimationFrame(() => {
          this.measure();
          this.startAutoplay();
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        window.clearTimeout(this.scrollTimer);
        this.stopAutoplay();
      }

      measure() {
        if (!this.track || this.cards.length === 0) {
          return;
        }

        this.hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.isRtl = window.getComputedStyle(this.track).direction === 'rtl';
        this.classList.toggle('is-static', !this.hasOverflow);
        this.updateControls();

        if (!this.hasOverflow) {
          this.stopAutoplay();
        } else if (!this.autoplayTimer) {
          this.startAutoplay();
        }
      }

      getStep() {
        const card = this.cards[0];
        if (!card || !this.track) {
          return 0;
        }

        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      isAtStart() {
        return !this.track || Math.abs(this.track.scrollLeft) <= 2;
      }

      isAtEnd() {
        return !this.track || Math.abs(this.track.scrollLeft) + this.track.clientWidth >= this.track.scrollWidth - 2;
      }

      move(direction) {
        if (!this.track || !this.hasOverflow) {
          return;
        }

        this.stopAutoplay();
        const loop = this.dataset.loop === 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (direction > 0 && this.isAtEnd()) {
          if (loop) {
            this.track.scrollTo({ left: 0, behavior: 'auto' });
          } else {
            this.updateControls();
            return;
          }
        } else if (direction < 0 && this.isAtStart()) {
          if (loop) {
            const endPosition = this.track.scrollWidth - this.track.clientWidth;
            this.track.scrollTo({ left: this.isRtl ? -endPosition : endPosition, behavior: 'auto' });
          } else {
            this.updateControls();
            return;
          }
        } else {
          this.track.scrollBy({
            left: direction * this.getStep() * (this.isRtl ? -1 : 1),
            behavior: reducedMotion ? 'auto' : 'smooth'
          });
        }

        this.scheduleAutoplayRestart();
      }

      handleScroll() {
        this.stopAutoplay();
        this.updateControls();
        this.scheduleAutoplayRestart();
      }

      updateControls() {
        const loop = this.dataset.loop === 'true';
        const disabled = !this.hasOverflow;

        if (this.previousButton) {
          this.previousButton.disabled = disabled || (!loop && this.isAtStart());
        }

        if (this.nextButton) {
          this.nextButton.disabled = disabled || (!loop && this.isAtEnd());
        }
      }

      pause() {
        this.paused = true;
        this.stopAutoplay();
      }

      resume() {
        this.paused = false;
        this.startAutoplay();
      }

      scheduleAutoplayRestart() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.startAutoplay(), 180);
      }

      startAutoplay() {
        this.stopAutoplay();
        const enabled = this.dataset.autoplay === 'true';

        if (
          !enabled
          || !this.hasOverflow
          || this.paused
          || document.hidden
          || (this.dataset.loop !== 'true' && this.isAtEnd())
          || window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          return;
        }

        const interval = Math.max(3000, Number(this.dataset.autoplayInterval) || 5000);
        this.autoplayTimer = window.setTimeout(() => this.move(1), interval);
      }

      stopAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    customElements.define('social-follow-gallery', SocialFollowGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-video-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('youtube-video-gallery')) {
    class YouTubeVideoGallery extends HTMLElement {
      connectedCallback() {
        this.layout = this.dataset.layout;
        this.track = this.querySelector('[data-youtube-stories-track]');
        this.shell = this.querySelector('[data-youtube-stories-shell]');
        this.cards = [...this.track.querySelectorAll(':scope > [data-youtube-card]')];
        this.previousButton = this.querySelector('[data-youtube-previous]');
        this.nextButton = this.querySelector('[data-youtube-next]');
        this.dialog = this.querySelector('[data-youtube-dialog]');
        this.player = this.querySelector('[data-youtube-player]');
        this.quickOrderHost = this.querySelector('[data-youtube-quick-order]');
        this.closeButton = this.querySelector('[data-youtube-close]');
        this.abortController = new AbortController();
        this.autoplayTimer = null;
        this.autoplayFallbackTimer = null;
        this.scrollTimer = null;
        this.inlinePlayer = null;
        this.previewGeneration = 0;
        this.activeIndex = 0;
        this.activeCard = null;
        this.autoplayPaused = false;
        this.lastTrigger = null;
        this.loopReady = false;
        this.loopEnabled = false;
        this.hasOverflow = false;
        this.hasPlayableVideos = this.cards.some((card) => Boolean(card.dataset.videoId));
        const signal = this.abortController.signal;

        this.classList.toggle('is-empty', this.cards.length === 0);

        if (this.layout === 'carousel' && this.cards.length > 1) {
          this.setupInfiniteLoop();
        }

        this.allCards = [...this.track.querySelectorAll(':scope > [data-youtube-card]')];

        this.previousButton?.addEventListener('click', () => this.move(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.move(1), { signal });
        this.track?.addEventListener('scroll', () => this.handleScroll(), { signal, passive: true });
        this.track?.addEventListener('pointerdown', () => this.pauseAutoplay(), { signal, passive: true });
        this.track?.addEventListener('pointerup', () => this.resumeAutoplay(), { signal, passive: true });
        this.track?.addEventListener('pointercancel', () => this.resumeAutoplay(), { signal, passive: true });
        this.addEventListener('focusin', () => this.pauseAutoplay(), { signal });
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) {
              this.resumeAutoplay();
            }
          });
        }, { signal });
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-youtube-play]');
          if (trigger && this.contains(trigger)) {
            this.openVideo(trigger);
          }
        }, { signal });
        this.closeButton?.addEventListener('click', () => this.dialog?.close(), { signal });
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            this.dialog.close();
          }
        }, { signal });
        this.dialog?.addEventListener('close', () => this.closeVideo(), { signal });
        this.quickOrderHost?.addEventListener('variant:add', () => this.dialog?.close(), { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        }, { signal });
        window.addEventListener('resize', () => this.handleResize(), { signal, passive: true });

        requestAnimationFrame(() => {
          this.measureCarousel();
          if (this.layout === 'carousel' && this.loopReady) {
            this.jumpTo(this.loopStart);
          }
          this.updateActiveIndex();
          this.updateControls();
          this.startAutoplay();
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.stopAutoplay();
        window.clearTimeout(this.scrollTimer);
        this.player?.replaceChildren();
        this.quickOrderHost?.replaceChildren();
      }

      setupInfiniteLoop() {
        const before = this.cards.map((card) => this.createLoopClone(card));
        const after = this.cards.map((card) => this.createLoopClone(card));
        this.track.prepend(...before);
        this.track.append(...after);
        this.loopReady = true;
      }

      createLoopClone(card) {
        const clone = card.cloneNode(true);
        clone.dataset.youtubeCarouselClone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => element.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', '-1'));
        return clone;
      }

      measureCarousel() {
        const card = this.cards[0];
        if (this.layout !== 'carousel' || !card || !this.track) {
          this.cardStep = 0;
          this.cycleWidth = 0;
          this.loopStart = 0;
          this.visibleCount = this.cards.length;
          this.hasOverflow = false;
          this.loopEnabled = false;
          this.classList.add('is-static');
          return;
        }

        const sectionStyles = window.getComputedStyle(this);
        const countProperty = window.matchMedia('(max-width: 699px)').matches
          ? '--youtube-stories-mobile-cards-per-view'
          : window.matchMedia('(max-width: 999px)').matches
            ? '--youtube-stories-tablet-cards-per-view'
            : '--youtube-stories-cards-per-view';
        const configuredCount = Math.max(1, Math.round(parseFloat(sectionStyles.getPropertyValue(countProperty)) || 1));
        this.visibleCount = configuredCount;
        this.hasOverflow = this.cards.length > configuredCount;
        this.loopEnabled = this.loopReady && this.hasOverflow;
        this.classList.toggle('is-static', !this.hasOverflow);

        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        this.cardStep = card.offsetWidth + gap;
        this.cycleWidth = this.cards.length * this.cardStep;
        this.loopStart = this.loopReady ? this.cycleWidth : 0;

        const media = card.querySelector('.youtube-video-card__media-shell');
        if (media && this.shell) {
          const trackBounds = this.track.getBoundingClientRect();
          const mediaBounds = media.getBoundingClientRect();
          const arrowTop = mediaBounds.top - trackBounds.top + mediaBounds.height / 2;
          this.shell.style.setProperty('--youtube-stories-arrow-top', `${arrowTop}px`);
        }
      }

      move(direction) {
        if (this.layout !== 'carousel' || !this.hasOverflow || !this.cardStep) {
          return;
        }

        this.stopAutoplay();
        this.normalizeLoop();
        this.track.scrollBy({
          left: direction * this.cardStep,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      scrollToCard(index) {
        if (!this.track || !this.cardStep || !Number.isFinite(index)) {
          return;
        }

        const safeIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        const centerOffset = Math.floor(this.visibleCount / 2) * this.cardStep;
        this.track.scrollTo({
          left: this.loopStart + safeIndex * this.cardStep - centerOffset,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      handleScroll() {
        this.stopAutoplay();
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => {
          this.normalizeLoop();
          this.updateActiveIndex();
          this.startAutoplay();
        }, 140);
      }

      normalizeLoop() {
        if (!this.loopEnabled || !this.cycleWidth || !this.cardStep || !this.track) {
          return;
        }

        const lowerBoundary = this.loopStart - this.cardStep / 2;
        const upperBoundary = this.loopStart + this.cycleWidth - this.cardStep / 2;
        if (this.track.scrollLeft < lowerBoundary) {
          this.jumpTo(this.track.scrollLeft + this.cycleWidth);
        } else if (this.track.scrollLeft >= upperBoundary) {
          this.jumpTo(this.track.scrollLeft - this.cycleWidth);
        }
      }

      jumpTo(left) {
        if (!this.track || !Number.isFinite(left)) {
          return;
        }

        const previousBehavior = this.track.style.scrollBehavior;
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = left;
        requestAnimationFrame(() => {
          this.track.style.scrollBehavior = previousBehavior;
        });
      }

      updateActiveIndex() {
        if (this.layout !== 'carousel' || !this.track || this.cards.length === 0) {
          this.activeIndex = 0;
          this.updateActiveState();
          return;
        }

        const trackBounds = this.track.getBoundingClientRect();
        const focusPoint = trackBounds.left + trackBounds.width / 2;
        let closestCard = null;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.allCards.forEach((card) => {
          const bounds = card.getBoundingClientRect();
          const distance = Math.abs(bounds.left + bounds.width / 2 - focusPoint);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestCard = card;
          }
        });

        this.activeCard = closestCard;
        this.activeIndex = Number(closestCard?.dataset.logicalIndex) || 0;
        this.updateActiveState();
      }

      updateActiveState() {
        this.allCards.forEach((card) => {
          const isActive = card === this.activeCard;
          card.classList.toggle('is-active', isActive);
          if (isActive) {
            card.setAttribute('aria-current', 'true');
          } else {
            card.removeAttribute('aria-current');
          }
        });
      }

      updateControls() {
        const disabled = this.layout !== 'carousel' || !this.hasOverflow;
        if (this.previousButton) {
          this.previousButton.disabled = disabled;
        }
        if (this.nextButton) {
          this.nextButton.disabled = disabled;
        }
      }

      pauseAutoplay() {
        this.autoplayPaused = true;
        this.stopAutoplay();
      }

      resumeAutoplay() {
        this.autoplayPaused = false;
        this.startAutoplay();
      }

      startAutoplay() {
        this.stopAutoplay();
        const enabled = this.dataset.autoplay === 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (
          this.layout !== 'carousel'
          || !enabled
          || reducedMotion
          || document.hidden
          || this.autoplayPaused
          || this.dialog?.open
          || !this.hasOverflow
          || !this.hasPlayableVideos
        ) {
          return;
        }

        this.updateActiveIndex();
        const interval = Math.max(3000, Number(this.dataset.autoplayInterval) || 3000);
        this.style.setProperty('--youtube-stories-autoplay-duration', `${interval}ms`);
        if (this.activeCard?.dataset.videoId) {
          void this.offsetWidth;
          this.classList.add('is-autoplay-running');
        }
        this.playInlinePreview(this.activeCard, interval);
      }

      stopAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        window.clearTimeout(this.autoplayFallbackTimer);
        this.autoplayTimer = null;
        this.autoplayFallbackTimer = null;
        this.classList.remove('is-autoplay-running');
        this.stopInlinePreview();
      }

      async playInlinePreview(card, interval) {
        const videoId = card?.dataset.videoId;
        const container = card?.querySelector('[data-youtube-inline-player]');
        if (!videoId || !container) {
          this.schedulePreviewFallback(this.previewGeneration, interval);
          return;
        }

        const generation = ++this.previewGeneration;
        this.autoplayFallbackTimer = window.setTimeout(
          () => this.schedulePreviewFallback(generation, interval),
          6000
        );

        try {
          const YouTube = await this.loadYouTubePlayerApi();
          if (generation !== this.previewGeneration || this.autoplayPaused || this.dialog?.open) {
            return;
          }

          const mount = document.createElement('div');
          container.replaceChildren(mount);
          container.hidden = false;
          container.setAttribute('aria-hidden', 'false');

          this.inlinePlayer = new YouTube.Player(mount, {
            videoId,
            playerVars: {
              autoplay: 0,
              controls: 0,
              disablekb: 1,
              fs: 0,
              iv_load_policy: 3,
              playsinline: 1,
              rel: 0
            },
            events: {
              onReady: (event) => {
                if (generation !== this.previewGeneration) {
                  event.target.destroy();
                  return;
                }

                event.target.mute();
                event.target.playVideo();
              },
              onStateChange: (event) => {
                if (
                  generation === this.previewGeneration
                  && event.data === YouTube.PlayerState.PLAYING
                  && !this.autoplayTimer
                ) {
                  window.clearTimeout(this.autoplayFallbackTimer);
                  this.autoplayFallbackTimer = null;
                  this.autoplayTimer = window.setTimeout(() => {
                    if (generation === this.previewGeneration) {
                      this.move(1);
                    }
                  }, interval);
                }
              },
              onAutoplayBlocked: () => this.schedulePreviewFallback(generation, interval),
              onError: () => this.schedulePreviewFallback(generation, interval)
            }
          });
        } catch (error) {
          this.schedulePreviewFallback(generation, interval);
        }
      }

      schedulePreviewFallback(generation, interval) {
        if (generation !== this.previewGeneration || this.autoplayTimer) {
          return;
        }

        window.clearTimeout(this.autoplayFallbackTimer);
        this.autoplayFallbackTimer = null;
        this.autoplayTimer = window.setTimeout(() => {
          if (generation === this.previewGeneration) {
            this.move(1);
          }
        }, interval);
      }

      stopInlinePreview() {
        this.previewGeneration += 1;

        try {
          this.inlinePlayer?.destroy();
        } catch (error) {
          // The iframe can already be detached while the carousel is moving.
        }

        this.inlinePlayer = null;
        this.allCards?.forEach((card) => {
          const container = card.querySelector('[data-youtube-inline-player]');
          if (container) {
            container.replaceChildren();
            container.hidden = true;
            container.setAttribute('aria-hidden', 'true');
          }
        });
      }

      handleResize() {
        const activeIndex = this.activeIndex;
        this.stopAutoplay();
        this.measureCarousel();
        if (this.loopReady && this.cardStep) {
          const centerOffset = Math.floor(this.visibleCount / 2) * this.cardStep;
          this.jumpTo(this.loopStart + activeIndex * this.cardStep - centerOffset);
        }
        this.updateActiveIndex();
        this.updateControls();
        this.startAutoplay();
      }

      loadYouTubePlayerApi() {
        if (window.YT?.Player) {
          return Promise.resolve(window.YT);
        }

        if (!window.youtubeVideoStoriesApiPromise) {
          window.youtubeVideoStoriesApiPromise = new Promise((resolve, reject) => {
            let script = document.querySelector('script[src*="youtube.com/iframe_api"]');

            if (!script) {
              script = document.createElement('script');
              script.src = 'https://www.youtube.com/iframe_api';
              script.async = true;
              document.head.appendChild(script);
            }

            let attempts = 0;
            const checkApi = window.setInterval(() => {
              attempts += 1;

              if (window.YT?.Player) {
                window.clearInterval(checkApi);
                resolve(window.YT);
              } else if (attempts >= 200) {
                window.clearInterval(checkApi);
                reject(new Error('YouTube player API did not load.'));
              }
            }, 50);

            script.addEventListener('error', () => {
              window.clearInterval(checkApi);
              reject(new Error('YouTube player API failed to load.'));
            }, { once: true });
          });
        }

        return window.youtubeVideoStoriesApiPromise;
      }

      openVideo(trigger) {
        const videoId = trigger.dataset.videoId;
        if (!videoId || !this.dialog || !this.player) {
          return;
        }

        this.lastTrigger = trigger;
        this.pauseAutoplay();
        const card = trigger.closest('[data-youtube-card]');
        const productTemplate = card?.querySelector('[data-youtube-product-template]');

        this.quickOrderHost?.replaceChildren();
        if (this.quickOrderHost && productTemplate) {
          this.quickOrderHost.appendChild(productTemplate.content.cloneNode(true));
          this.quickOrderHost.hidden = false;
          window.Shopify?.PaymentButton?.init();
        } else if (this.quickOrderHost) {
          this.quickOrderHost.hidden = true;
        }

        const iframe = document.createElement('iframe');
        const encodedId = encodeURIComponent(videoId);
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodedId}?autoplay=1&playsinline=1&rel=0`;
        iframe.title = trigger.getAttribute('aria-label') || 'YouTube video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.player.replaceChildren(iframe);
        this.dialog.showModal();
      }

      closeVideo() {
        this.player?.replaceChildren();
        this.quickOrderHost?.replaceChildren();
        if (this.quickOrderHost) {
          this.quickOrderHost.hidden = true;
        }
        this.autoplayPaused = false;
        this.lastTrigger?.focus({ preventScroll: true });
        this.lastTrigger = null;
        requestAnimationFrame(() => {
          this.autoplayPaused = false;
          this.startAutoplay();
        });
      }
    }

    customElements.define('youtube-video-gallery', YouTubeVideoGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
